var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-invite-list"},_vm._l((_vm.list),function(item){return _c('Item',_vm._b({key:item.uuid,on:{"toggle":function($event){return _vm.toggle(item)}}},'Item',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }